import React from 'react'
import ReactLoading from 'react-loading'

export enum ButtonTypes {
  primary = 'primary',
  secondary = 'secondary'
}

interface ButtonProps {
  bgColor?: string | undefined
  buttonType?: ButtonTypes
  children?: React.ReactElement
  className?: string
  disabled?: boolean
  loading?: boolean
  onClick?: (e: any) => void
  text?: string
  wrapperClass?: string | ''
  [rest: string]: any
};

/* NOTE!!!
When enhancing this component, follow the ButtonType pattern and deprecate the ability
to pass in bgColor, wrapperClass, and className, so that we can properly encapsulate
UX and avoid duplicate code.
*/
const Button: React.FC<ButtonProps> = ({ bgColor = 'bg-dopage-primary', buttonType, children, className, disabled, loading, text, wrapperClass = '', ...rest }: ButtonProps) => {
  if (typeof buttonType === 'string' && buttonType === ButtonTypes.secondary) {
    return (
      <div>
        <button
          disabled={disabled}
          className={`font-primary ${disabled === true ? 'bg-dopage-disabled' : 'bg-dopage-lightGreen'} diamond-btn h-[80px] w-[210px] font-bold p-[3px]`}
          {...rest}
        >
          <div className='bg-[#030303] w-full h-full flex justify-center items-center diamond-btn'>
            <span className='font-bold text-[26px] text-dopage-lightGreen'>{text}</span>
          </div>
        </button>
      </div>
    )
  } else {
    return (
      <div className={wrapperClass} data-testid='button-wrapper'>
        <button disabled={disabled} className={`font-primary ${disabled === true ? 'bg-dopage-disabled' : bgColor} ${className ?? ''}`} {...rest}>
          {loading === true ? <ReactLoading type='bubbles' color='black' height={64} width={64} /> : children}
        </button>
      </div>
    )
  }
}

export default Button
